// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessInformation_wrapper__uikBH"};